module.exports = __webpack_public_path__ + "static/media/torah.9588adc8.svg";